// Dependencies
import debounce from '../principles/performance/debounce';
import matchViewport from '../principles/responsive/match-viewport';
import throttle from '../principles/performance/throttle';

//

(function() {
  var
  $html = $('html'),
  $navControl = $('.site-nav-control'),
  $navOverlay = $('.offscreen-overlay'),
  $nav = $('.site-nav'),
  $navContainer = $('.site-nav__container'),
  $navMenus = $nav.find('.site-nav__menu'),
  $navSubmenus = $nav.find('.site-nav__submenu'),
  $navSearchInputs = $('.nav-search__input'),
  $window = $(window),

  offscreenNavOpenClass = 'offscreen-nav-open',
  fullNavOpenClass = 'full-nav-open',

  containerMenuOpenClass = 'site-nav__container--menu-is-open',
  containerSubmenuOpenClass = 'site-nav__container--submenu-is-open',
  activeParentClass = 'site-nav__link--menu-parent-active',

  menuOpenClass = 'site-nav__menu--is-open',

  transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend',
  menuTimeout = 250,

  getRelatedMenu = function($link) {
    return $('#' + $link.attr('aria-controls'));
  },

  init = function() {
    if (matchViewport('width-xxl')) {
      fullNav.setup();
      offscreenNav.teardown();
    } else {
      fullNav.teardown();
      offscreenNav.setup();
    }
  },

  offscreenNav = {
    isOpen: false,
    isSetup: false,

    close: function() {
      if (!offscreenNav.isOpen) return;
      offscreenNav.isOpen = false;
      $html.removeClass(offscreenNavOpenClass);
    },

    open: function() {
      if (offscreenNav.isOpen) return;
      offscreenNav.isOpen = true;
      $html.addClass(offscreenNavOpenClass);
    },

    setup: function() {
      if (offscreenNav.isSetup) return;
      offscreenNav.isSetup = true;

      $navControl.on('click.offscreen-nav', function(){
        if( offscreenNav.isOpen ) {
          offscreenNav.close();
        } else {
          offscreenNav.open();
        }
      });

      $navOverlay.on('click.offscreen-overlay', offscreenNav.close);

      $html.on(transitionEnd, function() {
        if (!offscreenNav.isOpen) {
          offscreenNav.closeMenu();
          offscreenNav.closeSubmenu();

          $nav.find('.' + menuOpenClass).removeClass(menuOpenClass);
        }
      });

      offscreenNav.setupMenus();
    },

    teardown: function() {
      if (!offscreenNav.isSetup) return;
      offscreenNav.isSetup = false;

      if (offscreenNav.isOpen) {
        $navOverlay.trigger('click');
      }

      $navControl.off('click.offscreen-nav');
      $navOverlay.off('click.offscreen-overlay');
      $html.off(transitionEnd);

      offscreenNav.teardownMenus();
    },

    // Offscreen nav menus ----------------

    isMenuOpen: false,

    closeMenu: function() {
      offscreenNav.isMenuOpen = false;
      $navContainer.removeClass(containerMenuOpenClass);
    },

    closeSubmenu: function() {
      $navContainer.removeClass(containerSubmenuOpenClass);
    },

    menuClosed: function() {
      $navMenus.removeClass(menuOpenClass);
    },

    openMenu: function($link) {
      offscreenNav.isMenuOpen = true;
      $navContainer.addClass(containerMenuOpenClass);
      getRelatedMenu($link).addClass(menuOpenClass);
    },

    openSubmenu: function($link) {
      $navContainer.addClass(containerSubmenuOpenClass);
      $navSubmenus.removeClass(menuOpenClass);
      getRelatedMenu($link).addClass(menuOpenClass);
    },

    setupMenus: function() {
      $nav.on('click.offscreen-nav-link', '.site-nav__link--menu-parent', function() {
        offscreenNav.openMenu($(this));
        return false;
      });

      $nav.on('click.offscreen-nav-link', '.site-nav__link--submenu-parent', function() {
        offscreenNav.openSubmenu($(this));
        return false;
      });

      $nav.on('click.offscreen-nav-back', '.site-nav__back', function() {
        if ($(this).hasClass('site-nav__back--submenu')) {
          offscreenNav.closeSubmenu();
        } else {
          offscreenNav.closeMenu();
        }
      });

      $navContainer.on(transitionEnd, function() {
        if (!offscreenNav.isMenuOpen) {
          offscreenNav.menuClosed();
        }
      });
    },

    teardownMenus: function() {
      $nav.off('click.offscreen-nav-link');
      $nav.off('click.offscreen-nav-back');
      $navContainer.off(transitionEnd);
    }
  },

  fullNav = {
    isSetup: false,

    closeMenu: function($menu, closeAll) {
      var $context = closeAll ? $navMenus : $menu;
      $context.removeClass(menuOpenClass);
      $('.site-nav__link').removeClass(activeParentClass);
      $navSearchInputs.blur();
      $('.nav-search__menu').hide();
    },

    openMenu: function($menu, $link) {
      setTimeout(() => {
        if ($menu.data('isHovering')) {
          fullNav.closeMenu($menu, true);
          $menu.addClass(menuOpenClass);
          $link.addClass(activeParentClass);
        }
      }, menuTimeout);
    },

    setup: function() {

      // TODO:
      //  handle keyboard navigation
      //  https://varsity.atlassian.net/browse/ECOM-131

      if (fullNav.isSetup) {
        return;
      }

      var
      hasPendingTouch = false,
      isHoveringInMenu = false;

      fullNav.isSetup = true;

      // Bind nav event handlers
      $nav
        .on('touchstart.full-nav-link', '.site-nav__link--menu-parent', function() {

            hasPendingTouch = true;

            $window.on('scroll.full-nav-link', throttle(() => { hasPendingTouch = false; }, 250));
          })
        .on('touchend.full-nav-link', '.site-nav__link--menu-parent', function(e) {
            e.preventDefault();

            var $link = $(this);

            $window.off('scroll.full-nav-link');

            if (hasPendingTouch === true) {

              let
              $relatedMenu = getRelatedMenu($link),
              isMenuOpen = $relatedMenu.hasClass(menuOpenClass);

              isMenuOpen
                ? fullNav.closeMenu($relatedMenu)
                : fullNav.openMenu($relatedMenu, $link);
            }
          })
        .on(
          `focusin.full-nav-link
           mouseenter.full-nav-link`,
          '.site-nav__link--menu-parent',
          function() {
            var $link = $(this);
            getRelatedMenu($link).data('isHovering', true);
            fullNav.openMenu(getRelatedMenu($link), $link);
          })
        .on('mouseleave.full-nav-link', '.site-nav__link--menu-parent', function() {
            var $link = $(this);
            getRelatedMenu($link).data('isHovering', false);

            // slight delay before checking to close menu
            window.setTimeout(function() {
              isHoveringInMenu = $html.hasClass(fullNavOpenClass);

              if (!isHoveringInMenu) {
                fullNav.closeMenu(getRelatedMenu($link));
              }
            }, 50);
          })
        .on('click.full-nav-link', '.site-nav__link--menu-parent', function(e) {
            e.preventDefault();
          });

      // Bind nav menu event handlers
      $navMenus
        .on('mouseenter.full-nav-link', function() {
          $html.addClass(fullNavOpenClass);
        })
        .on('mouseleave.full-nav-link', function(e) {
          if ($(e.target).closest('.nav-search').length > 0) {
            return;
          }

          fullNav.closeMenu('', true);
          $html.removeClass(fullNavOpenClass);
        });

      // Bind and event handler to hide any open menus when anything other than a menu item is
      // clicked
      $html.on('click.full-nav-menu', function(e) {

        var
        isMenuChild,
        isSearchBox,
        isMenuOpen = $navMenus.filter('.' + menuOpenClass).length > 0;

        if (isMenuOpen) {
          isMenuChild = $(e.target).closest('.site-nav__menu').length > 0;
          isSearchBox = $(e.target).closest('.nav-search').length > 0;

          if (!isMenuChild && !isSearchBox) {
            fullNav.closeMenu(null, true);
          }
        }
      });
    },

    teardown: function() {
      if (!fullNav.isSetup) return;
      fullNav.isSetup = false;

      $nav.off(`
        click.full-nav-link
        focusin.full-nav-link
        mouseenter.full-nav-link
        mouseleave.full-nav-link
        touchstart.full-nav-link
        touchend.full-nav-link`);
      $navMenus.off(`
        mouseenter.full-nav-link
        mouseleave.full-nav-link`);
      $html.off('click.full-nav-menu');
    }
  };

  init();
  $(window).on('resize', debounce(init, 250));
}());



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/components/site-nav.js
 **/